<template>
	<FormSearchableInput2
		ref="searchable"
		:selected="selected"
		:list="searchList"
		:is-search-loading="isLoading"
		v-bind="$attrs"
		:search="handleSearch"
		drop-class="w-96"
		@update:text="$emit('update:text', $event)"
		@update:selected="$emit('update:selected', $event)">
		<!-- Item da busca: dados suficientes para identificar a remessa sem sair da tela !-->
		<template #item="{ data: { item } }">
			<div class="flex items-start gap-3">
				<div class="min-w-0 flex-1">
					<!-- Rastreio !-->
					<p class="font-semibold truncate">{{ item.tracking_code }}</p>
					<!-- Origem e destino !-->
					<p class="text-xs truncate opacity-75">{{ route(item) }}</p>
					<!-- Parceiro e data !-->
					<p class="text-xs truncate opacity-75">{{ details(item) }}</p>
				</div>
				<!-- Status !-->
				<div v-if="hasStatus(item)" class="flex-none">
					<ShipmentStatusBadge :shipment="item"/>
				</div>
			</div>
		</template>
	</FormSearchableInput2>
</template>
<script>
import dayjs from "dayjs"

import Shipments from "@/API/Shipments.js"
import LoadingMixins from "@/mixins/loading.js"
import FormSearchableInput2 from "@/components/FormSearchableInput2.vue"
import ShipmentStatusBadge from "@/domain/shipments/ShipmentStatusBadge.vue"

export default {
	name: "ShipmentSearchSelect",
	mixins: [LoadingMixins],
	model: {
		prop: 'selected',
		event: 'update:selected'
	},
	props: {
		selected: [Object, Number, String],
		disabled: Boolean,
	},
	components: {
		FormSearchableInput2,
		ShipmentStatusBadge
	},
	data() {
		return {
			searchList: []
		}
	},
	methods: {
		/**
		 * Action search
		 * @param search
		 * @returns {Promise<Array>}
		 */
		async handleSearch(search) {

			this.loading()
			const [err, res] = await Shipments.list({search})
			this.loaded()

			if (err) {
				// TODO...
				return []
			}

			// A busca traz a remessa completa: expomos o tracking_code como label,
			// que é o formato que o FormSearchableInput2 usa para exibir e para o blur.
			return (res.data?.data ?? []).map(shipment => ({
				...shipment,
				label: shipment.tracking_code
			}))
		},
		/**
		 * O badge estoura se o status não vier na busca, então checamos antes
		 * (filled é global do helpers, mas não fica visível no template)
		 * @param item { Object }
		 * @returns {boolean}
		 */
		hasStatus(item) {
			return filled(item.shipment_status)
		},
		/**
		 * Origem e destino da remessa
		 * @param item { Object }
		 * @returns {string}
		 */
		route(item) {
			return [item.from_name, item.to_name].filter(filled).join(' → ')
		},
		/**
		 * Parceiro e data de criação, para separar remessas parecidas
		 * @param item { Object }
		 * @returns {string}
		 */
		details(item) {

			const details = []

			const partner = this.$data_get(item, 'partner.name')

			if (filled(partner)) details.push(partner)

			if (filled(item.created_at)) details.push(dayjs(item.created_at).format('DD/MM/YYYY'))

			return details.join(' · ')
		},
		focus() {
			this.$refs.searchable.focus()
		},
		clear() {
			this.$refs.searchable.clear()
		}
	}
}
</script>
